import produce from 'immer';

const INITIAL_STATE = {
  opened: false,
};

export default function dialog(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@dialog/OPEN': {
        draft.opened = true;
        break;
      }

      // Adicionar case
case '@atendimentoPosto/SUCCESS_REMOVE':
      case '@operacaoradadmdadosfaturamentoseplag/SUCCESS_REMOVE':
      case '@unidadeSaldoCota/SUCCESS_REMOVE':
      case '@saldoCotaOrgaoLista/SUCCESS_REMOVE':
      case '@auditoriaParametros/SUCCESS_REMOVE':
      case '@perfil/SUCCESS_REMOVE':
      case '@operacaoveiculomanutencaounidata/SUCCESS_IN_REQUEST':
      case '@cadastroterminal/SUCCESS_REMOVE':
      case '@cadastroposto/SUCCESS_REMOVE':
      case '@cadastrousuariomaster/SUCCESS_REMOVE':
      case '@operacaoimpedimentos/SUCCESS_REMOVE':
      case '@operacaoprerecebimento/SUCCESS_REMOVE':
      case '@operacaoprerecebimentolista/SUCCESS_REQUEST':
      case '@arqueacoes/SUCCESS_REMOVE':
      case '@bico/SUCCESS_REMOVE':
      case '@centrocusto/SUCCESS_REMOVE':
      case '@comboio/SUCCESS_REMOVE':
      case '@configuracaoalarmetanque/SUCCESS_REMOVE':
      case '@contrato/SUCCESS_REMOVE':
      case '@empresasveiculo/SUCCESS_REMOVE':
      case '@marcasveiculo/SUCCESS_REMOVE':
      case '@medidor/SUCCESS_REMOVE':
      case '@modelosveiculo/SUCCESS_REMOVE':
      case '@motorista/SUCCESS_REMOVE':
      case '@operacao/SUCCESS_REMOVE':
      case '@operacaoabastecimento/SUCCESS_REMOVE':
      case '@operacaoestoqueposto/SUCCESS_REMOVE':
      case '@operacaoestoquetanque/SUCCESS_REMOVE':
      case '@operacaorecebimento/SUCCESS_REMOVE':
      case '@posto/SUCCESS_REMOVE':
      case '@produto/SUCCESS_REMOVE':
      case '@tanquesfisicos/SUCCESS_REMOVE':
      case '@tanquesvirtual/SUCCESS_REMOVE':
      case '@terminal/SUCCESS_REMOVE':
      case '@usuario/SUCCESS_REMOVE':
      case '@veiculo/SUCCESS_REMOVE':
      case '@estoqueproduto/SUCCESS_REMOVE':
      case '@operacaoafericaoveiculo/SUCCESS_REMOVE':
      case '@frentista/SUCCESS_REMOVE':
      case '@orgao/SUCCESS_REMOVE':
      case '@unidade/SUCCESS_REMOVE':
      case '@postoplanejamento/SUCCESS_REMOVE':
      case '@auth/SIGN_OUT':
      case '@dialog/CLOSE': {
        draft.opened = false;
        break;
      }

      default:
    }
  });
}
